<script>
export default {
  name: 'InvoiceEditLayout',
  props: {
    isSecondaryLayout: Boolean
  }
}
</script>

<template>
  <div :class="{
        'row': true,
        'wrapper': true,
        'secondary': isSecondaryLayout
      }">
    <div class="col left-column">
      <slot name="left-column"></slot>
    </div>
    <div class="col right-column">
      <div class="right-column-content">
        <slot name="right-column"></slot>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.wrapper {
  flex-wrap: nowrap;
}

.left-column, .right-column {
  transition: flex 300ms, max-width 300ms;
}

.left-column {
  flex: 3 1 0;
  max-width: 1400px;
}

.right-column {
  flex: 2 1 0;
  max-width: 100%;
  min-width: 415px;
}

.wrapper.secondary {
  .left-column {
    flex-grow: 3;
  }

  .right-column {
    flex-grow: 1;
    max-width: 600px;
  }
}

.right-column-content {
  position: sticky;
  top: 1em;
}
</style>
